import { Button, Table } from "antd";
import { useEffect, useState } from "react";
//firebase imports
import { collection, where, query, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../firebase/config";

export default function KnivesTable(props) {
   const [knifeData, setKnifeData] = useState();
   const [pending, setIsPending] = useState();
   const [disableButton, setDisableButton] = useState(false);

   const getData = async () => {
      //firebase query
      const q = query(collection(db, "knives"), where("width", ">=", props.minWidth), where("width", "<=", props.maxWidth), orderBy("width"));

      //init results from firebase
      let results = [];

      //get init data based on min-max width from firebase
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
         results.push({ ...doc.data(), id: doc.id });
      });

      //filter the firebase data into smaller query
      const heightQuery = results.filter((data) => data.height >= props.minHeight && data.height <= props.maxHeight);
      console.log(results);

      //sets final table data into knife data
      setKnifeData(heightQuery);
      setIsPending(false);
   };

   const columns = [
      {
         title: "Code",
         dataIndex: "code",
      },
      {
         title: "Width",
         dataIndex: "width",
         sorter: {
            compare: (a, b) => a.width - b.width,
         },
      },
      {
         title: "Height",
         dataIndex: "height",
         sorter: {
            compare: (a, b) => a.width - b.width,
         },
      },
      {
         title: "Shape",
         dataIndex: "TypeOfForm",
         filters: [
            {
               text: "kvadrāts",
               value: "kvadrāts",
            },
            {
               text: "specforma",
               value: "specforma",
            },
            {
               text: "aplis",
               value: "aplis",
            },
            {
               text: "kvadrāts PERFO",
               value: "kvadrāts PERFO",
            },
            {
               text: "perfo",
               value: "Perfo",
            },
            {
               text: "specforma - perfo",
               value: "specforma - perfo",
            },
            {
               text: "specforma aplis",
               value: "specforma aplis",
            },
         ],
         onFilter: (value, record) => record.TypeOfForm.indexOf(value) === 0,
      },
      {
         title: "Rows",
         dataIndex: "rowss",
         sorter: {
            compare: (a, b) => a.rows - b.rows,
         },
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   //checks wether to disable the search button
   useEffect(() => {
      if (props.minWidth && props.minHeight && props.maxWidth && props.maxHeight) {
         setDisableButton(false);
      } else {
         setDisableButton(true);
      }
   }, [props.minWidth, props.minHeight, props.maxWidth, props.maxHeight]);

   return (
      <div>
         <Button disabled={disableButton} style={{ marginBottom: "15px", marginTop: "15px" }} onClick={getData} type="primary" block>
            Search
         </Button>

         <Table columns={columns} size="small" loading={pending} dataSource={knifeData} onChange={onChange} pagination={{ defaultPageSize: "10" }} />
      </div>
   );
}
